// ESM-Huelle fuer lib/scripts/components/CMP_CColumn.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CColumn (id)
{
    this.construct (id);

    this.name = "CColumn";    
    this.htmlType = "td";

    this.properties =
    {
        styles: {},
        events: {},
        attributes: {}
    }
}

CColumn.prototype = new CComponent;
export { CColumn };
